/**
* DevExpress Analytics (query-builder\dataSource\dbStoredProcedure.js)
* Version:  20.2.9
* Build date: Aug 16, 2021
* Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _dbSchema_1 = require("./_dbSchema");
var DBStoredProcedure = (function () {
    function DBStoredProcedure(model) {
        this.name = model['Name'];
        this.arguments = _dbSchema_1.deserializeToCollection(model['arguments'], function (argModel) { return new DBStoredProcedureArgument(argModel); });
    }
    return DBStoredProcedure;
}());
exports.DBStoredProcedure = DBStoredProcedure;
var DBStoredProcedureArgumentDirection;
(function (DBStoredProcedureArgumentDirection) {
    DBStoredProcedureArgumentDirection[DBStoredProcedureArgumentDirection["In"] = 0] = "In";
    DBStoredProcedureArgumentDirection[DBStoredProcedureArgumentDirection["Out"] = 1] = "Out";
    DBStoredProcedureArgumentDirection[DBStoredProcedureArgumentDirection["InOut"] = 2] = "InOut";
})(DBStoredProcedureArgumentDirection = exports.DBStoredProcedureArgumentDirection || (exports.DBStoredProcedureArgumentDirection = {}));
var DBStoredProcedureArgument = (function () {
    function DBStoredProcedureArgument(model) {
        this.name = model['Name'];
        this.type = model['Type'];
        this.direction = model['Direction'];
    }
    return DBStoredProcedureArgument;
}());
exports.DBStoredProcedureArgument = DBStoredProcedureArgument;
